/**
 * @name shrimp
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMmEzLjI4IDMuMjggMCAwMDMuMjI3IDEuNzk4bDYuMTctLjU2MUExIDEgMCAxMTE5LjYxNCA4SDguNWE2LjQ0IDYuNDQgMCAwMC01LjYzIDkuNzVBNi41IDYuNSAwIDAwOC41IDIxYzEuMzggMCAyLS41IDIuNS0xIiAvPgogIDxwYXRoIGQ9Ik0xMCA4YTguNSA4LjUgMCAwMDAgOCIgLz4KICA8cGF0aCBkPSJNMTEgMjJjLS41LS41LTEuMTItMS0yLjUtMWExIDEgMCAwMTAtNUgxMmE3IDcgMCAwMDctN1Y4IiAvPgogIDxwYXRoIGQ9Ik0xMyAxMmguMDEiIC8+CiAgPHBhdGggZD0iTTggMTZjLTIgMC00LjUtNC00LTYiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/shrimp
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const Shrimp: string = `
<svg
  class="lucide lucide-shrimp"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 2a3.28 3.28 0 003.227 1.798l6.17-.561A1 1 0 1119.614 8H8.5a6.44 6.44 0 00-5.63 9.75A6.5 6.5 0 008.5 21c1.38 0 2-.5 2.5-1" />
  <path d="M10 8a8.5 8.5 0 000 8" />
  <path d="M11 22c-.5-.5-1.12-1-2.5-1a1 1 0 010-5H12a7 7 0 007-7V8" />
  <path d="M13 12h.01" />
  <path d="M8 16c-2 0-4.5-4-4-6" />
</svg>
`;

export default Shrimp;
